<template>
  <div
      v-if="isShow"
      :class="['sc-bar', disable ? 'sc-bar__disable' : '']"
      :style="{ ...styleObject, borderColor: compBack }"
      @mousedown="mousedown"

      @touchstart="touchstart"
      @touchend="touchend"
      @touchmove="touchmove"
      :title="helpTitle"
  >
    <div class="sc-bar__delete"
         slot="reference"
         @mousedown="deleteEvent"
         @touchstart="deleteEvent"
         v-if="isWaiting && remote">
      <icon-close></icon-close>
    </div>

    <div @mousedown.self="mousedown">
      <transition name="fade">
        <div
            class="loading"
            v-if="loading || moving"
            :style="{ background: loadBackground }"
        ></div>
      </transition>

      <span class="sc-bar__client" v-if="user">{{ user.name || user.phone }}</span>

      <!--      <span class="head">-->
      <!--        <div class="tartTime time" style="margin: 5px 0" v-if="user">-->
      <!--          {{ user.phone }}-->
      <!--        </div>-->
      <!--      </span>-->

    </div>
  </div>
</template>

<script>
import IconClose from "@/components/icons/close.vue";
import {mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
  name: "ReservedDiv",
  props: {
    rowIndex: {
      required: true,
    },
    keyNo: Number,
    unitHeight: Number,
    unitWidth: Number,
    titleDivHeight: Number,
    borderHeight: Number,
    dateStart: {},
    dateEnd: {},
    user: {},
    minDate: {},
    maxDate: {},
    unit: Number,
    clearSwitch: Boolean,
    dragenterRowIndex: {
      required: true,
    },
    dragenterKeyIndex: Number,
    isSelecting: Boolean,
    isSelectingRowIndex: Number,
    isSelectingIndex: Number,
    nowDate: null,
    moving: {
      type: Boolean,
      default: false,
    },
    remote: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    id: Number,
  },
  data: function () {
    return {
      moveStart: null,
      moveStartOffset: null,
      clientY: null,
      styleObject: {
        opacity: 1,
        top: "0px",
        left: "0px",
        height: "0px",
        zIndex: 10
      },
      isShow: false,
      mouseYStarted: null,
      startLineNo: null,
      endLineNo: null,
      isEdit: false,
      isMove: false,
      loading: false,
      confirmDelete: false,
    };
  },
  components: {
    IconClose,
  },
  computed: {
    ...mapGetters("appointment", {
      currentDepartment: "currentDepartment",
    }),
    helpTitle () {
      return this.$root.dateTime( moment(this.dateStart).toDate()) + ' - ' + this.$root.dateTime( moment(this.dateEnd).toDate())
    },
    loadBackground() {
      let color;
      if (this.loading) color = "#f6f8f9"
      if (this.moving) color = "#f6f8f9"

      return (
          color +
          " url(" +
          require("@/assets/load.svg") +
          ") center/50px no-repeat"
      );
    },
    compBack() {
      return this.inProcess
          ? "#FFD791"
          : this.isWaiting
              ? "#EE4266"
              : "#43D3B3"
    },
    inProcess() {
      if (moment(this.dateEnd).toDate() >= this.nowDate && this.nowDate < moment(this.dateStart).toDate())
        return true
      else return false
    },
    isWaiting() {
      if (this.nowDate >= moment(this.dateEnd).toDate()) {
        return false
      } else return true
    },

  },
  created() {
    if (this.$root.convertTimeZone(this.dateStart, 'Europe/Moscow') - this.$root.convertTimeZone(this.minDate, 'Europe/Moscow')
        < 0 && this.$root.convertTimeZone(this.dateEnd, 'Europe/Moscow') - this.$root.convertTimeZone(this.minDate, 'Europe/Moscow') < 0) {
      return;
    }
    this.setLeftPosition();
    this.setHeight();
    this.isShow = true
  },
  watch: {
    isMove() {
      function MouseWheelHandler(e) {
        if (this.isMove) {
          e.preventDefault()
          e.stopPropagation()
          return false;
        }
      }

      if (this.isMove) {
        window.addEventListener("mousewheel", MouseWheelHandler, {passive: false})
      } else {
        window.removeEventListener("mousewheel", MouseWheelHandler)
      }
    },
    dateStart(newVal, oldVal) {

      if (newVal != oldVal) {
        this.startDate = newVal
        this.setLeftPosition()
      }


    },
    dateEnd(newVal, oldVal) {
      if (newVal != oldVal) {

        this.endDate = newVal;
        this.setHeight();
        if (this.isSelecting &&
            this.mouseYStarted &&
            this.rowIndex == this.isSelectingRowIndex &&
            this.keyNo == this.isSelectingIndex
        ) {
          let diff = this.getMinutesDiff(new Date(oldVal), new Date(newVal))
          let cnt = parseInt(diff / this.unit)
          this.mouseYStarted += this.unitHeight * cnt
        }
      }
    },
    dragenterKeyIndex() {
    },

  },
  methods: {
    ...mapActions({
      getAppointment: "appointment/GET_APPOINTMENT",
    }),
    min(t) {
      return t.substr(10, 6);
    },
    setLeftPosition() {
      let leftDiff = this.getMinutesDiff(
          moment(this.minDate).toDate(),
          moment(this.dateStart).toDate()
      );


      let shiftCnt = parseInt(leftDiff / this.unit);
      this.startLineNo = shiftCnt;
      let shiftLeft = this.unitHeight * shiftCnt - this.borderHeight + 76

      this.styleObject.top = shiftLeft + "px"

    },
    getMinutesDiff(date1, date2) {
      const diffTime = date2 - date1
      return Math.ceil(diffTime / (1000 * 60))
    },
    setHeight() {
      let rightDiff = this.getMinutesDiff(
          new Date(this.dateStart),
          new Date(this.dateEnd)
      );
      let heightCnt = parseInt(rightDiff / this.unit)
      this.endLineNo = this.startLineNo + heightCnt
      let height = this.unitHeight * heightCnt * this.borderHeight - 8
      this.styleObject.height = height + "px"
    },

    moveEnd(e) {
      if (!this.isMove) return

      let moveXPx = e - this.moveStart

      this.$nextTick(() => {

        if (moveXPx === 0 && this.confirmDelete === false) this.$emit('click-event')
      })

      let unitCnt = parseInt(moveXPx / this.unitHeight)
      let halfheight = parseInt(this.unitHeight / 2)
      let modXPx = parseInt(moveXPx % this.unitHeight)
      if (moveXPx < 0 && Math.abs(modXPx) >= halfheight) {
        unitCnt--
      }
      this.mouseYStarted = null
      this.styleObject.Opacity = 1
      this.styleObject.zIndex = 10

      this.isMove = false

      if (unitCnt != 0 || this.dragenterRowIndex != this.rowIndex) {
        this.$emit("move-schedule-data", this.rowIndex, this.keyNo, unitCnt)
      }

      if (unitCnt === 0) {
        this.styleObject.top = parseInt(this.moveStartOffset) + "px"
      }
    },


    touchstart(e) {
      if (!this.isWaiting) return
      e.preventDefault()
      this.moveStart = e.touches[0].clientY

      this.styleObject.Opacity = 0.5
      this.isMove = true
      this.$emit("set-dragenter-row-and-index", this.rowIndex, null)

      this.moveStartOffset = this.styleObject.top
    },
    touchmove(e) {
      this.styleObject.top = (e.targetTouches[0].clientY - this.moveStart) + parseInt(this.moveStartOffset) + "px"
    },
    touchend(e) {
      e.preventDefault();
      let mouseXEnd = e.changedTouches[0].clientY
      this.moveEnd(mouseXEnd)
    },

    deleteEvent(e) {
      if (this.loading) return

      this.confirmDelete = true
      e.preventDefault()

      this.$confirm('Запись будет удалена', 'Удалить запись?', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Отмена',
        type: 'warning'
      }).then(() => {

        this.loading = true;
        this.styleObject.Opacity = "0.8"

        this.$api.appointments
            .delete(this.currentDepartment.id, this.id)
            .then(() => {
              this.$emit("delete-schedule-data", this.rowIndex, this.keyNo)

              this.$notify.success({
                title: "Удачно...",
                message: "Запись удалена",
              })
            })
            .catch((response) => {
              this.$notify.error({
                title: "Ошибка уления 😕",
                message: response.response.data.message,
              });
            })
            .finally(() => {
              this.loading = false;
              this.styleObject.Opacity = "1"

              this.getAppointment()
            });


      }).catch(() => {

      }).finally(() => {
        this.confirmDelete = false
      });


    },


    mousedown(e) {
      console.log('mousedown', e)

      e.preventDefault();

      this.moveStart = e.clientY;

      this.styleObject.Opacity = 0.5;
      this.styleObject.zIndex = 999;

      this.isMove = true;
      this.$emit("set-dragenter-row-and-index", this.rowIndex, null);
      this.$emit("mousedown");

      this.moveStartOffset = this.styleObject.top;


      document.onmousemove = ((e) => {

        if (!this.isMove) return;
        this.styleObject.top = (e.pageY - this.moveStart) + parseInt(this.moveStartOffset) + "px";
      });
      document.onmouseup = ((e) => {
        this.moveEnd(e.pageY)
      });


    },


  },
};
</script>
<style scoped lang="scss">
.sc-bar {
  position: absolute;

  cursor: pointer;
  z-index: 10;

  font-size: 12px;
  color: #111;
  line-height: 13px;
  letter-spacing: 0.005em;
  overflow: hidden;

  background: #FFFFFF;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  border-radius: 6px;

  border-top: 4px solid #43D3B3;

  margin: 0 8px;
  width: calc(100% - 16px);

  .head {
    display: block;
    padding: 0 6px;
    font-size: 12px;
    overflow: hidden;
  }

  &__client {
    font-weight: 600;
    font-size: 12px;
    line-height: 13px;

    display: block;
    padding: 5px 8px;
    font-weight: bold;
    overflow: hidden;
  }

  &__delete {
    position: absolute;
    z-index: 15;
    top: 5px;
    right: 6px;
  }

  &__last {
    background: #32e6be;
  }

  &__disable {
    cursor: no-drop;
    background: repeating-linear-gradient(
            -45deg,
            #606dbc00,
            #606dbc00 10px,
            #e5e6ea 10px,
            #e5e6ea 20px
    );
  }
}

.sc-bar_resizable {
  cursor: n-resize;
  height: 4px;

  bottom: 0;
  width: 100%;
  z-index: 90;
  position: absolute;
  font-size: 0.1px;
  display: block;

  background: repeating-linear-gradient(
          -45deg,
          #606dbc00,
          #606dbc00 10px,
          #ccc 10px,
          #ccc 20px
  );

  &__process {
    background: repeating-linear-gradient(
            -45deg,
            #606dbc00,
            #606dbc00 10px,
            #41cfae 10px,
            #41cfae 20px
    );
  }

  &__waiting {
    background: repeating-linear-gradient(
            -45deg,
            #606dbc00,
            #606dbc00 10px,
            #b7e1db 10px,
            #b7e1db 20px
    );
  }
}

.loading {
  position: absolute;
  left: 0;
  right: 0;

  height: 100%;
  background-position: center center;
  background-size: cover;

  transition: background 0.4s ease;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
